import React, { useState, useEffect } from "react";
import { useParams, useLocation, Navigate, useNavigate } from "react-router-dom";
import axios from "axios";
import { Container, Row, Col, Form, Button, Card, Alert, Spinner } from "react-bootstrap";
import { Trash2, Image, PlusCircle, AlertCircleIcon } from "lucide-react";
import color from "../../../UI/color";
import axiosInstance from "../../../services/http/interceptors/GlobalInterciptor";
import "./omrahDetails.modules.css"
import mobile from "./Mobile_login-bro_1[1].png"
import { isUserLoggedIn } from "../../../auth/utiles";
import toast from "react-hot-toast";
import booked from "./booked.png"
import LoadingSpinner from "../../../components/LoadingSpinner/LoadingSpinner";
import ReactQuill from "react-quill";
const OmrahDetails = () => {
  const navigate = useNavigate();
  let token = localStorage.getItem("token")
  const { id } = useParams(); // Get the program ID from the URL
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const type = queryParams.get("type") || "Umrah"; // Default to "Umrah" if no type is provided

  const [program, setProgram] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [parentName, setParentName] = useState("");
  const [participants, setParticipants] = useState([
    { name: "", occupation: "", address: "", age: "", passportImage: null, personalImage: null },
  ]);
  const [eTransferReceipt, setETransferReceipt] = useState(null);
  const [errors, setErrors] = useState({});
  const [isSubmitted, setIsSubmitted] = useState(false);

  // Fetch program details based on ID and type
  useEffect(() => {
    const fetchProgramDetails = async () => {
      try {
        const response = await axiosInstance.get(
          `/api/mobile/events/${id}?type=${type}`
        );
        setProgram(response.data?.data);
        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };

    fetchProgramDetails();
  }, [id, type]);




  // const handleAddToCart = async () => {
  //   if (program.remaining_seats < 1) {
  //     toast.error("No seats available");
  //     return;
  //   }

  //   try {
  //     let formData = new FormData();
  //     formData.append("model_id", String(id));
  //     formData.append("model_name", "Event");
  //     formData.append("name", parentName);
  //     // File validation function
  //     const validateFileType = (file) => {
  //       return file && ["image/jpeg", "image/png", "image/jpg"].includes(file.type);
  //     };

  //     // Append participant details dynamically
  //     console.log(participants);

  //     for (let index = 0; index < participants.length; index++) {
  //       const participant = participants[index];

  //       // Validate passport image
  //       if (participant.passport && !validateFileType(participant.passport)) {
  //         toast.error(`Participant ${index + 1}: Passport must be a jpg, jpeg, or png file.`);
  //         return;
  //       }

  //       // Validate personal photo
  //       if (participant.photo && !validateFileType(participant.photo)) {
  //         toast.error(`Participant ${index + 1}: Personal image must be a jpg, jpeg, or png file.`);
  //         return;
  //       }

  //       formData.append(`data[${index}][name]`, participant.name);
  //       formData.append(`data[${index}][age]`, participant.age);
  //       formData.append(`data[${index}][occupation]`, participant.occupation);
  //       formData.append(`data[${index}][address]`, participant.address);
  //       formData.append(`data[${index}][passport]`, participant.passportImage);
  //       formData.append(`data[${index}][photo]`, participant.personalImage);
  //     }

  //     const response = await axiosInstance.post("/api/cart/add", formData, {
  //       headers: {
  //         "Content-Type": "multipart/form-data",

  //       },
  //     });

  //     if (response.data?.status) {
  //       toast.success("Added to cart successfully!");
  //       console.log("Added to cart:", response.data);
  //     } else {
  //       toast.error(response.data?.message || "Failed to add to cart.");
  //       console.error("API Error:", response.data?.message);
  //     }
  //   } catch (err) {
  //     const errorMessage = err.response?.data?.message || err.message || "An unexpected error occurred";

  //     if (err.response?.data?.errors) {
  //       Object.entries(err.response.data.errors).forEach(([key, messages]) => {
  //         messages.forEach((msg) => toast.error(msg)); // Show each validation error
  //       });
  //     } else {
  //       toast.error(` ${errorMessage}`);
  //     }

  //     console.error("API error:", errorMessage);
  //   }
  // };




  const handleAddToCart = async () => {

    setIsSubmitted(true)
    if (!validateForm("cart")) {
      console.log("Form validation failed");
     return;
    }
    if (program.remaining_seats < 1) {
      toast.error("No seats available");
      return;
    }


    try {
      let formData = new FormData();
      formData.append("model_id", String(id));
      formData.append("model_name", "Event");
      formData.append("name", parentName);

      // File validation function
      const validateFileType = (file) => {
        return file && ["image/jpeg", "image/png", "image/jpg"].includes(file.type);
      };

      // Append participant details dynamically
      console.log(participants);

      for (let index = 0; index < participants.length; index++) {
        const participant = participants[index];

        // Validate passport image
        if (participant.passport && !validateFileType(participant.passport)) {
          toast.error(`Participant ${index + 1}: Passport must be a jpg, jpeg, or png file.`);
          return;
        }

        // Validate personal photo
        if (participant.photo && !validateFileType(participant.photo)) {
          toast.error(`Participant ${index + 1}: Personal image must be a jpg, jpeg, or png file.`);
          return;
        }

        formData.append(`data[${index}][name]`, participant.name);
        formData.append(`data[${index}][age]`, participant.age);
        formData.append(`data[${index}][occupation]`, participant.occupation);
        formData.append(`data[${index}][address]`, participant.address);
        formData.append(`data[${index}][passport]`, participant.passportImage);
        formData.append(`data[${index}][photo]`, participant.personalImage);
      }

      const response = await axiosInstance.post("/api/cart/add", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (response.data?.status) {
        toast.success("Added to cart successfully!");
        console.log("Added to cart:", response.data);

        // ✅ Reset Fields After Successful Submission
        setParticipants([]); // Clear participants
        setParentName(""); // Clear parent name
        document.querySelectorAll('input[type="file"]').forEach((input) => (input.value = "")); // Reset file inputs

        // ✅ Refresh the page after a short delay
        setTimeout(() => {
          window.location.reload();
        }, 1000); // Delay refresh slightly to let the toast message show

      } else {
        toast.error(response.data?.message || "Failed to add to cart.");
        console.error("API Error:", response.data?.message);
      }
    } catch (err) {
      const errorMessage = err.response?.data?.message || err.message || "An unexpected error occurred";

      if (err.response?.data?.errors) {
        validateForm(); // Call form validation function

        // Show only one toast message instead of looping through each error
        toast.error("Fill all required fields");
      } else {
        toast.error(errorMessage);
      }


      console.error("API error:", errorMessage);
    }
  };


  // Handle changes in participant fields
  const handleParticipantChange = (index, field, value) => {
    const newParticipants = [...participants];
    newParticipants[index][field] = value;
    setParticipants(newParticipants);

    if (errors[`participant${field}${index}`]) {
      const newErrors = { ...errors };
      delete newErrors[`participant${field}${index}`];
      setErrors(newErrors);
    }
  };


  // Add a new participant
  const addParticipant = () => {
    setParticipants([
      ...participants,
      { name: "", occupation: "", address: "", age: "", passportImage: null, personalImage: null },
    ]);
  };

  // Delete a participant
  const deleteParticipant = (index) => {
    const newParticipants = participants.filter((_, i) => i !== index);
    setParticipants(newParticipants);
  };

  // Validate the form
  const validateForm = (type) => {
    const newErrors = {};

    if (!parentName.trim()) {
      newErrors.parentName = "Parent name is required";
    }

    participants.forEach((participant, index) => {
      if (!participant.name.trim()) {
        newErrors[`participantName${index}`] = "Participant name is required";
      }
      if (!participant.occupation.trim()) {
        newErrors[`participantOccupation${index}`] = "Occupation is required";
      }
      if (!participant.address.trim()) {
        newErrors[`participantAddress${index}`] = "Address is required";
      }
      if (!participant.age || participant.age <= 0) {
        newErrors[`participantAge${index}`] = "Age must be a positive number";
      }
      if (!participant.passportImage) {
        newErrors[`participantPassportImage${index}`] = "Passport image is required";
      }
      if (!participant.personalImage) {
        newErrors[`participantPersonalImage${index}`] = "Personal image is required";
      }
    });

    if (!eTransferReceipt && type == "submit") {
      newErrors.eTransferReceipt = "E-Transfer receipt is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitted(true);
   setLoading(true)

    if (!validateForm("submit")) {
      console.log("Form validation failed");
      setLoading(false)
      return;
    }

    // Prepare data for API request
    const formData = new FormData();
    formData.append("event_id", id); // Add event ID
    formData.append("name", parentName); // Add parent name

    // Add participant data
    participants.forEach((participant, index) => {
      formData.append(`data[${index}][name]`, participant.name);
      formData.append(`data[${index}][occupation]`, participant.occupation);
      formData.append(`data[${index}][address]`, participant.address);
      formData.append(`data[${index}][age]`, participant.age);
      formData.append(`data[${index}][passport]`, participant.passportImage);
      formData.append(`data[${index}][photo]`, participant.personalImage);
    });

    // Add E-Transfer receipt
    formData.append("receipt", eTransferReceipt);

    try {
      const response = await axiosInstance.post(
        "/api/mobile/eventsEnrollFree",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",

          },
        }
      );
setLoading(false)

      if (response.data?.status) {
        toast.success("Data Submited successfully!");
        console.log("Added to cart:", response.data);
      } else {
        toast.error(response.data?.msg || "Failed to add to cart.");
        console.error("API Error:", response.data?.msg);
      }
    } catch (err) {
      setLoading(false)
      const errorMessage = err.response?.data?.msg || err.message || "An unexpected error occurred";

      if (err.response?.status === 500 && errorMessage.includes("Not Enough Available Seats")) {
        toast.error("Not enough seats available. Please choose another program.");
      } else {
        toast.error(`Error: ${errorMessage}`);
      }

      console.error("API error:", errorMessage);
    }
  };

  if (loading) {
    return (
      <div className="LoaderDiv">
     <LoadingSpinner></LoadingSpinner>
      </div>
    );
  }
  if (error) return <div>Error: {error}</div>;

  return (
    <>
      {/* Header Section */}
   
      <div className="text-center position-relative">
  <img
    src={program.image_en}
    alt={`${type} Camp`}
    className="img w-100 "
    style={{
      height: "auto",
      maxHeight: "462px",
      objectFit: "cover",
    }}
  />

  {/* Overlay */}
  <div
  className="position-absolute top-0 start-0 w-100 h-100"
  style={{
    background: "linear-gradient(to top, rgba(0, 0, 0, 0.3), transparent)",
    zIndex: 0,
  }}
></div>


  {/* Title */}
  <div
    className="text-white position-absolute bottom-0 start-0 ms-3 mb-1"
    style={{
      fontSize: "clamp(16px, 4vw, 24px)",
      fontWeight: "bold",
      zIndex: 1,
    }}
  >
    {program.title_en}   

    
  </div>
</div>


      {/* Main Container */}
      <Container className="my-5">
        <Row className="justify-content-between">
          {/* Left Column: Program Details */}


          <Col md={8} className="mb-4 px-md-5">
            <div className="rounded-3">
              {/* <h4
                className="mb-4 p-3 rounded-3 text-center text-md-start"
                style={{
                  color: color.ButtonsColor,
                  backgroundColor: "rgba(240, 243, 244, 1)",
                }}
              >
                {program.title_en}
              </h4>

              <p className="text-muted text-center text-md-start px-2">
                Estimating on our {type} package promises a journey filled with comfort,
                convenience, and enriching experiences. Here are some expectations you can
                look forward to:
              </p> */}

              {/* Dynamic Title and Description */}
              {program.description.map((item) => (
                <div key={item.id} className="mb-4 ">
                  <h5
                    className="p-3 rounded-3 text-center text-md-start fw-semibold mb-4"
                    style={{
                      color: color.ButtonsColor,
                      backgroundColor: "rgba(240, 243, 244, 1)",
                    }}
                  >
                    {item.title}
                  </h5>
                  {/* <p className="text-muted px-2 text-center text-md-start text-wrap mb-4 ">{item.description}</p> */}
                  <ReactQuill theme="bubble" value={item.description} readOnly={true} />
                </div>
              ))}
            </div>
          </Col>


          {/* Right Column: Participant Form */}
          { }
          {program.remaining_seats < 1 ? <Col md={4} className="  border-1 p-4 " style={{ backgroundColor: "rgba(247, 253, 255, 1)", border: "0.5px solid rgb(220, 230, 233)", width: "390px", height: "309px" }}> <img src={booked} alt="" srcset="" className="w-100 mt-5 " />  </Col> : token ? (<Col md={4} >
            <Card style={{ backgroundColor: "rgba(247, 253, 255, 1)" }}>
              <Card.Title
                className="text-center text-white py-3 mb-4 rounded-top-2 "
                style={{ backgroundColor: "rgba(19, 178, 188, 1)", position: "relative" }}
              >

                Total Price ${program.price * participants.length}
                <span className="tooltip-container ms-1 ">
                  <AlertCircleIcon size={20} className="mb-3" />
                  <span className="tooltip-text ">This is additional info about the total price.</span>
                </span>
              </Card.Title>

              <Card.Body>
                <Form onSubmit={handleSubmit} className=" p-2">
                  {/* Parent Name */}
                  <Row className="mb-3" style={{ color: "rgba(131, 128, 128, 1)", }}>
                    <Col>

                      <Form.Group controlId="parentName">
                        <Form.Label className="fw-bold ms-1">Parent Details*</Form.Label>
                        <Form.Control

                          type="text"
                          className="custom-placeholder form-control w-100  "
                          style={{ backgroundColor: "rgba(247, 253, 255, 1) ", border: "1px solid rgba(151, 176, 187, 1) ", width: "366px", height: "45px" }}
                          placeholder="Parent Full Name* "
                          value={parentName}
                          onChange={(e) => setParentName(e.target.value)}
                          isInvalid={isSubmitted && !!errors.parentName}
                        />
                        {isSubmitted && errors.parentName && (
                          <Form.Control.Feedback type="invalid">
                            {errors.parentName}
                          </Form.Control.Feedback>
                        )}
                      </Form.Group>
                    </Col>
                  </Row>

                  {/* Participants */}
                  {participants.map((participant, index) => (
                    <div key={index} className="mb-4  border-0 rounded position-relative text-start" style={{ color: "rgba(131, 128, 128, 1)" }} >
                      <h5 className="fw-bold p-2" style={{ fontSize: "16px" }}>Participant {index + 1}</h5>
                      {index !== 0 && (
                        <button
                          className="  position-absolute top-0 end-0  btn text-danger mb-2 "
                          // style={{  width:"40px" }}
                          onClick={() => deleteParticipant(index)}
                        >
                          <Trash2 size={15} className="mb-2" />
                        </button>
                      )}
                      <Col >
                        <Form.Group controlId={`participantName${index}`} className="mb-3 text-start">

                          <Form.Control
                            type="text"
                            className="custom-placeholder form-control w-100 "
                            style={{ backgroundColor: "rgba(247, 253, 255, 1) ", border: "1px solid rgba(151, 176, 187, 1) ", width: "366px", height: "45px" }}
                            placeholder="Name*"
                            value={participant.name}
                            onChange={(e) => handleParticipantChange(index, "name", e.target.value)}
                            isInvalid={isSubmitted && !!errors[`participantName${index}`]}
                          />
                          {isSubmitted && errors[`participantName${index}`] && (
                            <Form.Control.Feedback type="invalid">
                              {errors[`participantName${index}`]}
                            </Form.Control.Feedback>
                          )}
                        </Form.Group>
                      </Col>
                      <Form.Group controlId={`participantOccupation${index}`} className="mb-3">

                        <Form.Control
                          type="text"
                          className="custom-placeholder form-control w-100 "
                          style={{ backgroundColor: "rgba(247, 253, 255, 1) ", border: "1px solid rgba(151, 176, 187, 1) ", width: "366px", height: "45px" }}
                          placeholder="Occupation*"
                          value={participant.occupation}
                          onChange={(e) =>
                            handleParticipantChange(index, "occupation", e.target.value)
                          }
                          isInvalid={isSubmitted && !!errors[`participantOccupation${index}`]}
                        />
                        {isSubmitted && errors[`participantOccupation${index}`] && (
                          <Form.Control.Feedback type="invalid">
                            {errors[`participantOccupation${index}`]}
                          </Form.Control.Feedback>
                        )}
                      </Form.Group>
                      <Form.Group controlId={`participantAddress${index}`} className="mb-3">

                        <Form.Control
                          type="text"
                          className="custom-placeholder form-control w-100 "
                          style={{ backgroundColor: "rgba(247, 253, 255, 1) ", border: "1px solid rgba(151, 176, 187, 1) ", width: "366px", height: "45px" }}
                          placeholder="Address* "
                          value={participant.address}
                          onChange={(e) =>
                            handleParticipantChange(index, "address", e.target.value)
                          }
                          isInvalid={isSubmitted && !!errors[`participantAddress${index}`]}
                        />
                        {isSubmitted && errors[`participantAddress${index}`] && (
                          <Form.Control.Feedback type="invalid">
                            {errors[`participantAddress${index}`]}
                          </Form.Control.Feedback>
                        )}
                      </Form.Group>
                      <Form.Group controlId={`participantAge${index}`} className="mb-3 ">

                        <Form.Control
                          type="number"
                          className="custom-placeholder form-control w-100  "
                          style={{ backgroundColor: "rgba(247, 253, 255, 1) ", border: "1px solid rgba(151, 176, 187, 1) ", width: "366px", height: "45px" }}
                          placeholder="Age* "
                          value={participant.age}
                          onChange={(e) => handleParticipantChange(index, "age", e.target.value)}
                          isInvalid={isSubmitted && !!errors[`participantAge${index}`]}
                        />
                        {isSubmitted && errors[`participantAge${index}`] && (
                          <Form.Control.Feedback type="invalid">
                            {errors[`participantAge${index}`]}
                          </Form.Control.Feedback>
                        )}
                      </Form.Group>

                      {/* Passport Image Upload */}
                      <Form.Group controlId={`participantPassportImage${index}`} className="mb-3">
                        <div className="custom-file-upload">
                          <label
                            htmlFor={`passportImageInput${index}`}
                            className="btn d-flex justify-content-between align-items-center w-100 pt-2 pt-md-0 "
                            style={{
                              height: "45px",
                              border: "1px solid rgba(151, 176, 187, 1)",
                              backgroundColor: "rgba(247, 253, 255, 1)",
                              padding: "0 10px",
                              overflow: "hidden",
                              textAlign: "left",
                            }}
                          >
                            {/* File Name with Proper Wrapping */}
                            <span
                              id={`passportFileName${index}`}
                              className="text-muted text-wrap d-flex"
                              style={{
                                display: "block",
                                maxWidth: "80%",
                                overflowWrap: "break-word",
                                wordBreak: "break-word",
                                fontSize: "1rem",
                              }}
                            >
                              {participant.passportImage ? participant.passportImage.name : "Passport Image"}
                            </span>
                            <Image color="rgba(151, 176, 187, 1)" size={20} className="d-none d-md-flex" />
                          </label>

                          <Form.Control
                            id={`passportImageInput${index}`}
                            type="file"
                            className="d-none w-100"
                            style={{ width: "366px", height: "45px" }}
                            onChange={(e) => {
                              const file = e.target.files?.[0] || null;
                              handleParticipantChange(index, "passportImage", file);
                              document.getElementById(`passportFileName${index}`).textContent =
                                file?.name || "Upload Passport Image";
                            }}
                            isInvalid={isSubmitted && !!errors[`participantPassportImage${index}`]}
                          />
                        </div>

                        {isSubmitted && errors[`participantPassportImage${index}`] && (
                          <div className="text-danger mt-2">
                            {errors[`participantPassportImage${index}`]}
                          </div>
                        )}
                      </Form.Group>

                      {/* Personal Image Upload */}
                      <Form.Group controlId={`participantPersonalImage${index}`} className="mb-3">
                        <div className="custom-file-upload">
                          <label
                            htmlFor={`personalImageInput${index}`}
                            className="btn d-flex justify-content-between align-items-center w-100 pt-2 pt-md-0"
                            style={{
                              height: "45px",
                              border: "1px solid rgba(151, 176, 187, 1)",
                              backgroundColor: "rgba(247, 253, 255, 1)",
                              padding: "0 10px",
                              overflow: "hidden",
                              textAlign: "left",
                            }}
                          >
                            {/* Allow long names to wrap properly */}
                            <span
                              id={`personalFileName${index}`}
                              className="text-muted text-wrap"
                              style={{
                                display: "block",
                                maxWidth: "80%",
                                overflowWrap: "break-word",
                                wordBreak: "break-word",
                                fontSize: "1rem",
                              }}
                            >
                              {participant.personalImage ? participant.personalImage.name : "Personal Image"}
                            </span>
                            <Image color="rgba(151, 176, 187, 1)" size={20} className="d-none d-md-flex" />
                          </label>

                          <Form.Control
                            id={`personalImageInput${index}`}
                            type="file"
                            className="d-none w-100"
                            style={{ width: "366px", height: "45px" }}
                            onChange={(e) => {
                              const file = e.target.files?.[0] || null;
                              handleParticipantChange(index, "personalImage", file);
                              document.getElementById(`personalFileName${index}`).textContent =
                                file?.name || "Upload Personal Image";
                            }}
                            isInvalid={isSubmitted && !!errors[`participantPersonalImage${index}`]}
                          />
                        </div>

                        {isSubmitted && errors[`participantPersonalImage${index}`] && (
                          <div className="text-danger mt-2">
                            {errors[`participantPersonalImage${index}`]}
                          </div>
                        )}
                      </Form.Group>
                    </div>
                  ))}

                  {/* Add Participant Button */}
                  <Row className="mb-3 ">
                    <Col>
                      <button
                        style={{ color: color.ButtonsColor, backgroundColor: "rgba(247, 253, 255, 1)" }}
                        onClick={addParticipant}
                        className="w-100 border-0  text-start fw-bolder d-flex justify-content-start align-items-start "

                      >
                        <PlusCircle className="me-2" />
                        Add New Participant
                      </button>
                    </Col>
                  </Row>

                  {/* Payment Options */}
                  <Row className="mb-3">
                    <Col md={12} >
                      <h5 className=" fw-bold ms-2" style={{ color: "rgba(131, 128, 128, 1)", fontSize: "16px" }}>Payment Options</h5>
                      <p className="text-muted ms-2 pb-2">
                        Upload E-Transfer and submit, Or add to cart to book with Paypal or Stripe.
                      </p>
                      {/* E-Transfer Receipt Upload */}
                      <Form.Group controlId="eTransferReceipt" className="mb-3">
                        <div className="custom-file-upload">
                          <label
                            htmlFor="eTransferReceiptInput"
                            className="btn d-flex justify-content-between align-items-center w-100 pt-2 pt-md-0"
                            style={{
                              height: "45px",
                              border: "1px solid rgba(151, 176, 187, 1)",
                              backgroundColor: "rgba(247, 253, 255, 1)",
                              padding: "0 10px",
                              overflow: "hidden",
                              textAlign: "left",
                            }}
                          >
                            {/* File Name with Wrapping Support */}
                            <span
                              id="eTransferFileName"
                              className="text-muted text-wrap"
                              style={{
                                display: "block",
                                maxWidth: "80%",
                                overflowWrap: "break-word",
                                wordBreak: "break-word",
                                fontSize: "1rem",
                              }}
                            >
                              {eTransferReceipt ? eTransferReceipt.name : "E-Transfer Receipt"}
                            </span>
                            <div className="d-flex justify-content-center align-items-center">


                              <Image color="rgba(151, 176, 187, 1)" size={20} className="d-none d-md-flex rounded-3" />
                            </div>

                          </label>

                          <Form.Control
                            id="eTransferReceiptInput"
                            type="file"
                            className="d-none w-100"
                            style={{ width: "366px", height: "45px" }}
                            onChange={(e) => {
                              const file = e.target.files?.[0] || null;
                              setETransferReceipt(file);
                              document.getElementById("eTransferFileName").textContent =
                                file?.name || "Upload E-Transfer Receipt";
                            }}
                            isInvalid={isSubmitted && !!errors.eTransferReceipt}
                          />
                        </div>

                        {isSubmitted && errors.eTransferReceipt && (
                          <div className="text-danger mt-2">{errors.eTransferReceipt}</div>
                        )}
                      </Form.Group>
                    </Col>
                  </Row>

                  {/* Submit and Add to Cart Buttons */}
                  <Row className="mb-3">
      <Col md={12} className="text-center d-flex justify-content-center align-items-center">
        
        {/* Submit Button with Spinner */}
        <Button
          variant="danger"
          type="submit"
          style={{ backgroundColor: "#ED5859", height: "50px" }}
          className="me-2 w-100 text-white fw-bold"
          onClick={handleSubmit}
          disabled={loading} // Disable button while loading
        >
          {loading ? (
            
              <LoadingSpinner>
            </LoadingSpinner>
          ) : (
            "Submit"
          )}
        </Button>

        {/* Add to Cart Button */}
        <Button
          variant="outline-danger"
          style={{ height: "50px" }}
          className="w-100 fw-bold"
          type="button"
          onClick={handleAddToCart}
        >
          Add To Cart
        </Button>
      </Col>
    </Row>
                </Form>
              </Card.Body>
            </Card>
          </Col>) : (

            <Col className="d-flex justify-content-center align-items-center vh-50">

              <Card className="text-center   border" style={{ maxWidth: "500px" }}>
                <Card.Title
                  className="text-center text-white py-3 mb-4 rounded-top-2"
                  style={{ backgroundColor: "rgba(19, 178, 188, 1)" }}
                >
                  Total Price ${program.price * participants.length}
                </Card.Title>
                <div className="text-center p-2">
                  <img
                    src={mobile}
                    alt="Login Illustration"
                    className="img-fluid mb-3"
                    style={{ maxHeight: "180px" }}
                  />
                </div>

                <h4 className="fw-bold ">You're not logged in</h4>
                <p className="text-muted">Log In or Register to Book Your Spot Now to show switched form.</p>

                <div className="d-flex justify-content-center gap-3 p-2">
                  <a href="/login" className="w-100"><Button style={{ backgroundColor: "rgba(237, 88, 89, 1)" }} variant="danger w-100" size="lg">Login</Button></a>
                  <a href="/sign-up" className="w-100">  <Button style={{ backgroundColor: "rgba(19, 178, 188, 1)" }} variant="primary w-100 border-0" size="lg">Sign Up</Button></a>
                </div>
              </Card>
            </Col>

          )}
        </Row>
      </Container>
    </>
  );
};

export default OmrahDetails;










